import { render, staticRenderFns } from "./WorkRecordItemCard.vue?vue&type=template&id=4a1f5bc2&scoped=true"
import script from "./WorkRecordItemCard.vue?vue&type=script&lang=js"
export * from "./WorkRecordItemCard.vue?vue&type=script&lang=js"
import style0 from "./WorkRecordItemCard.vue?vue&type=style&index=0&id=4a1f5bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1f5bc2",
  null
  
)

export default component.exports